export function asError(e: unknown, message = 'Unknown error'): Error {
  return e instanceof Error ? e : new Error(message, { cause: e });
}
